import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Loader } from "rsuite";
import SortDefault from "../../../assets/sort_default.svg";
import SortAsc from "../../../assets/sort_asc.svg";
import SortDsc from "../../../assets/sort_desc.svg";
import {
  numberFormatterForKorM,
  numberFormatterOnlyInM,
} from "../../../utils/formatter";

const GrowthVsTmTable = ({
  activeIndex,
  commGrowthFilter,
  salesGrowthFilter,
  tpGrowthFilter,
  drill,
  tableDataOG,
  isLoadingReportGrowthVsTmData,
}: {
  activeIndex: string;
  commGrowthFilter: string;
  salesGrowthFilter: string;
  tpGrowthFilter: string;
  drill: "Up" | "Down";

  tableDataOG: Array<
    Record<string, string | number> & {
      tm: number;
      sales: number;
      growth: number;
    }
  >;
  isLoadingReportGrowthVsTmData: boolean;
}) => {
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");
  const [tableData, setTableData] = useState<any>([]);

  useEffect(() => {
    if (tableDataOG && tableDataOG.length !== 0) setTableData(tableDataOG);
  }, [tableDataOG, activeIndex, drill]);

  const sortByColumnName = (
    data: any[],
    order: "asc" | "desc" | "",
    column: string,
  ) => {
    if (!order) return data;
    return [...data].sort((a, b) => {
      if (a[column] < b[column]) return order === "asc" ? -1 : 1;
      if (a[column] > b[column]) return order === "asc" ? 1 : -1;
      return 0;
    });
  };
  const handleSort = (columnName: string, sortType: any) => {
    let order: "asc" | "desc" | "" = "asc";
    if (columnName === sortColumn) {
      order = sortType !== "" ? (sortType === "asc" ? "desc" : "") : "asc";
    } else {
      order = "asc";
    }
    setSortColumn(columnName);
    setSortType(order);

    if (order) {
      setTableData(sortByColumnName(tableData, order, columnName));
    } else {
      setTableData(tableDataOG); // original order
    }
  };
  const renderSortIcon = (field: any) => {
    const iconSize = "w-full";
    if (sortColumn === field && sortType === "asc") {
      return <img width={iconSize} height={iconSize} src={SortAsc} alt="asc" />;
    } else if (sortColumn === field && sortType === "desc") {
      return (
        <img width={iconSize} height={iconSize} src={SortDsc} alt="desc" />
      );
    } else {
      return (
        <img
          // width={iconSize}
          // height={iconSize}
          className="w-full"
          src={SortDefault}
          alt="default"
        />
      );
    }
  };
  return (
    <div className="relative w-[35%] h-full bg-white">
      {isLoadingReportGrowthVsTmData ? (
        <div className="absolute inset-0 z-10 bg-black/50 flex items-center justify-center">
          <Loader
            backdrop
            size="md"
            vertical
            className="text-black font-bold"
          />
        </div>
      ) : (
        <div className="growth_table">
          <div className="px-2 pt-1 h-[7vh] border-1 border-black flex justify-start items-start">
            <div>
              <span className="font-bold text-[2vh] text-[#86BC25]">
                {drill === "Up" && activeIndex} {commGrowthFilter}{" "}
                {tpGrowthFilter}
              </span>
              <span className="font-bold text-[2vh]">
                {/* {drill === "Down" ? " District" : " Sales Office"} */}
                {` Performance`}
              </span>
            </div>
          </div>
          <DataTable
            value={tableData}
            stripedRows
            scrollable
            scrollHeight="67vh"
            showGridlines
          >
            <Column
              field="sub"
              header={() => (
                <div
                  className="w-full flex justify-between items-center cursor-pointer"
                  onClick={() => handleSort("sub", sortType)}
                >
                  <div className="w-[78%]">
                    {drill === "Down" ? "District" : "Sales Office"}
                  </div>
                  <div className="w-[0.8vw]">{renderSortIcon("sub")}</div>
                </div>
              )}
              style={{ width: "25%" }}
              body={(rowdata) => {
                return (
                  <div className="flex justify-between items-center gap-[0.5vw]">
                    <span>{rowdata.sub}</span>
                  </div>
                );
              }}
            ></Column>
            <Column
              field="growth"
              header={() => (
                <div
                  className="w-full flex justify-between items-center cursor-pointer"
                  onClick={() => handleSort("growth", sortType)}
                >
                  <div className="w-[75%]">
                    <span>YoY Sales</span>
                    <span>
                      {salesGrowthFilter === "Pounds(lbs)"
                        ? " (lbs) "
                        : " ($) "}
                      Growth
                    </span>
                  </div>
                  <div className="w-[0.8vw]">{renderSortIcon("growth")}</div>
                </div>
              )}
              style={{ width: "33%" }}
              body={(rowdata) => {
                return (
                  <div className="flex justify-end items-center gap-[0.5vw]">
                    <span>{rowdata.growth}%</span>
                  </div>
                );
              }}
            ></Column>
            <Column
              field="tm"
              header={() => (
                <div
                  className="w-full flex justify-between items-center cursor-pointer"
                  onClick={() => handleSort("tm", sortType)}
                >
                  <div className="w-[65%]">TM %</div>{" "}
                  <div className="w-[0.8vw]">{renderSortIcon("tm")}</div>
                </div>
              )}
              style={{ width: "17%" }}
              body={(rowdata) => {
                return (
                  <div className="flex justify-end items-center gap-[0.5vw]">
                    <span>{rowdata.tm}%</span>
                  </div>
                );
              }}
            ></Column>
            <Column
              field="sales"
              header={() => (
                <div
                  className="w-full flex justify-between items-center cursor-pointer"
                  onClick={() => handleSort("sales", sortType)}
                >
                  <div className="w-[75%]">
                    Sales{" "}
                    {salesGrowthFilter === "Pounds(lbs)" ? "(lbs)" : "($)"}
                  </div>
                  <div className="w-[0.8vw]">{renderSortIcon("sales")}</div>
                </div>
              )}
              style={{ width: "25%" }}
              body={(rowdata) => {
                return (
                  <div className="flex justify-end items-center gap-[0.5vw]">
                    <span>
                      {/* {numberFormatterOnlyInM(
                        rowdata.sales,
                        1,
                        salesGrowthFilter === "Pounds(lbs)" ? "" : "$",
                      )} */}
                      {numberFormatterForKorM(
                        rowdata.sales,
                        1,
                        salesGrowthFilter === "Pounds(lbs)" ? "" : "$",
                        drill === "Down" ? "M" : "K",
                      )}
                    </span>
                  </div>
                );
              }}
            ></Column>
          </DataTable>
        </div>
      )}
    </div>
  );
};

export default GrowthVsTmTable;
